<ion-content class="ion-padding">
  <div class="header">
    <img [src]="getImageUrl(user.imageUrl)" default="" />
    <div style="display: flex;flex-direction: column;">
        <span class="rank-user-name">{{ user.name }}</span> 
        <span class="rank-user-rank">{{ currentRank }}</span>
    </div>
  </div>

  <ion-item class="comments" lines="none">
    <ion-label position="stacked">
      {{ 'calibration.commentsNotes' | translate }}
    </ion-label>
    <ion-textarea rows="9" [(ngModel)]="user.notes"></ion-textarea>
  </ion-item>
  <ion-item class="mark" lines="none">
        <ion-checkbox mode="ios" [(ngModel)]="user.inReview"></ion-checkbox>
        {{ 'calibration.setRevision' | translate }}
    </ion-item>


    <ion-item class="comments" lines="none" *ngIf="evaluationLog && evaluationLog.length > 0">
        <ion-label position="stacked">
            {{ 'calibration.evaluationHistory' | translate }}
        </ion-label>
        <ion-grid>
            <ion-row *ngFor="let evaluation of evaluationLog">
                <ion-col size="4">
                    <b>{{ evaluation.date | date: 'dd/MM/yyyy hh:mm' }}</b>
                </ion-col>
                <ion-col size="6">
                    {{ evaluation.evaluator }}
                </ion-col>

                <ng-container *ngIf="useTranslationOnOverallEvaluation; else usePossibleValues">
                    <ion-col size="2" class="secondary">
                        {{ evaluation.finalEvaluationTranslated || '--' }}
                    </ion-col>
                </ng-container>
                <ng-template #usePossibleValues>
                    <ion-col size="2" class="secondary">
                        {{ evaluation.finalEvaluation || '--' }}
                    </ion-col>
                </ng-template>
            </ion-row>
        </ion-grid>
    </ion-item>
</ion-content>

<ion-footer mode="ios">
  <ion-toolbar mode="ios">
    <ion-row>
      <ion-col size="4"></ion-col>
      <ion-col size="3">
        <ion-button mode="ios" color="secondary" (click)="dismiss()">
          {{ 'generic.goBack' | translate }}
        </ion-button>
      </ion-col>
      <ion-col size="5">
        <ion-button color="primary" mode="ios" (click)="save()">
          {{ 'generic.save' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
